export const validateMail = (email) => {
    // Define the regular expression for phone number validation for NL, DE, and BE
    const mailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Test the phone number against the regex
    return mailRegex.test(email);
}